// extracted by mini-css-extract-plugin
export default {"modal":"history-modal_modal__BSyqI","table":"history-modal_table__FIK+k"};